import { getRequest } from '../request/request.service';
import { User } from './user.service.types';

export const USER_URL = 'users';

export async function getUser() {
  try {
    return await getRequest<User>(`${USER_URL}/user_data`);
  } catch (error: any) {
    if (error.response?.status === 401) {
      localStorage.removeItem('respondit:auth_t');
      window.location.href = '/sign-in';
    }
    throw error;
  }
}
